import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedAssetTypeModelSelector($companyId: ID!) {
    assetTypes(companyId: $companyId) {
      models
    }
  }
`
